/* Mi regalón — interacciones propias (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Revelado al hacer scroll (un único observador) ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mr-reveal:not(.mr-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mr-visible'); });
      return;
    }
    if (!window.__mrObs) {
      window.__mrObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('mr-visible'); window.__mrObs.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { window.__mrObs.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var imgs = document.querySelectorAll('[data-mr-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        if (window.innerWidth < 750) { img.style.transform = ''; return; }
        var box = img.parentElement.getBoundingClientRect();
        if (box.bottom < 0 || box.top > window.innerHeight) return;
        var intensity = parseFloat(img.getAttribute('data-mr-parallax')) || 0;
        img.style.transform = 'translate3d(0,' + (-box.top * intensity / 100) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(update); ticking = true; } }, { passive: true });
    update();
  }

  /* ---------- Cifras animadas ---------- */
  function initCifras() {
    var nums = document.querySelectorAll('[data-mr-contar]:not([data-mr-hecho])');
    if (!nums.length) return;
    function animar(el) {
      el.setAttribute('data-mr-hecho', '1');
      var fin = parseFloat(el.getAttribute('data-mr-contar')) || 0;
      var dur = parseInt(el.getAttribute('data-mr-duracion'), 10) || 1600;
      var out = el.querySelector('.mr-cifra__valor');
      if (reduce) { out.textContent = fin; return; }
      var t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);
        out.textContent = Math.round(fin * e);
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
      setTimeout(function () { out.textContent = fin; }, dur + 400);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(animar); return; }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { animar(e.target); obs.unobserve(e.target); } });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { obs.observe(n); });
  }

  /* ---------- Pasos con escena fija ---------- */
  function initPasos() {
    document.querySelectorAll('[data-mr-pasos]:not([data-mr-listo])').forEach(function (sec) {
      sec.setAttribute('data-mr-listo', '1');
      var pasos = sec.querySelectorAll('.mr-paso');
      var fotos = sec.querySelectorAll('.mr-pasos__escena img');
      var etiqueta = sec.querySelector('.mr-pasos__escena-num');
      if (!pasos.length) return;
      function activar(i) {
        pasos.forEach(function (p, j) { p.classList.toggle('mr-activo', i === j); });
        fotos.forEach(function (f, j) { f.classList.toggle('mr-activo', i === j); });
        if (etiqueta) etiqueta.textContent = etiqueta.getAttribute('data-plantilla').replace('#', i + 1).replace('%', pasos.length);
      }
      activar(0);
      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activar(Array.prototype.indexOf.call(pasos, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      pasos.forEach(function (p) { obs.observe(p); });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGaleria() {
    document.querySelectorAll('[data-mr-galeria]:not([data-mr-listo])').forEach(function (g) {
      g.setAttribute('data-mr-listo', '1');
      var fotos = g.querySelectorAll('.mr-galeria__principal img');
      var minis = g.querySelectorAll('.mr-galeria__miniatura');
      if (fotos.length < 2) return;
      var actual = 0;
      function ir(i) {
        actual = (i + fotos.length) % fotos.length;
        fotos.forEach(function (f, j) { f.classList.toggle('mr-activo', j === actual); });
        minis.forEach(function (m, j) {
          m.classList.toggle('mr-activo', j === actual);
          if (j === actual && m.scrollIntoView) m.parentElement.scrollTo({ left: m.offsetLeft - 20, behavior: 'smooth' });
        });
      }
      minis.forEach(function (m, j) { m.addEventListener('click', function () { ir(j); }); });
      var prev = g.querySelector('.mr-galeria__flecha--prev');
      var next = g.querySelector('.mr-galeria__flecha--next');
      if (prev) prev.addEventListener('click', function () { ir(actual - 1); });
      if (next) next.addEventListener('click', function () { ir(actual + 1); });
      var x0 = null;
      var principal = g.querySelector('.mr-galeria__principal');
      principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      principal.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) ir(actual + (dx < 0 ? 1 : -1));
        x0 = null;
      });
      g.__mrIr = function (mediaId) {
        fotos.forEach(function (f, j) { if (f.getAttribute('data-media-id') === String(mediaId)) ir(j); });
      };
    });
  }

  /* ---------- Compra: variantes, cantidad y barra móvil ---------- */
  function initCompra() {
    document.querySelectorAll('[data-mr-compra]:not([data-mr-listo])').forEach(function (box) {
      box.setAttribute('data-mr-listo', '1');
      var sec = box.closest('.mr-producto');
      var dataEl = sec.querySelector('[data-mr-variantes]');
      var variantes = dataEl ? JSON.parse(dataEl.textContent) : [];
      var inputsId = sec.querySelectorAll('input[name="id"]');
      var precio = sec.querySelectorAll('[data-mr-precio]');
      var antes = sec.querySelectorAll('[data-mr-antes]');
      var ahorro = sec.querySelectorAll('[data-mr-ahorro]');
      var botones = sec.querySelectorAll('[data-mr-boton]');
      var formato = box.getAttribute('data-mr-moneda') || '${{amount_no_decimals_with_comma_separator}}';
      var txtAgregar = box.getAttribute('data-mr-txt-agregar');
      var txtAgotado = box.getAttribute('data-mr-txt-agotado');
      var txtAhorro = box.getAttribute('data-mr-txt-ahorro') || 'Ahorras %';

      function dinero(cents) {
        var n = (cents / 100);
        var miles = function (s, sep) { return s.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
        var ent = Math.round(n).toString();
        var dec = n.toFixed(2).split('.');
        return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
          if (k === 'amount_no_decimals_with_comma_separator') return miles(ent, '.');
          if (k === 'amount_no_decimals_with_space_separator') return miles(ent, ' ');
          if (k === 'amount_no_decimals') return miles(ent, ',');
          if (k === 'amount_with_comma_separator') return miles(dec[0], '.') + ',' + dec[1];
          if (k === 'amount_with_apostrophe_separator') return miles(dec[0], "'") + '.' + dec[1];
          if (k === 'amount_with_space_separator') return miles(dec[0], ' ') + ',' + dec[1];
          return miles(dec[0], ',') + '.' + dec[1];
        });
      }

      box.querySelectorAll('.mr-opcion__valores input').forEach(function (inp) {
        inp.addEventListener('change', function () {
          var sel = [];
          box.querySelectorAll('.mr-opcion').forEach(function (op) {
            var c = op.querySelector('input:checked');
            sel.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) return;
          inputsId.forEach(function (i) { i.value = v.id; });
          precio.forEach(function (p) { p.textContent = dinero(v.price); });
          var tieneAntes = v.compare_at_price && v.compare_at_price > v.price;
          antes.forEach(function (a) { a.textContent = tieneAntes ? dinero(v.compare_at_price) : ''; a.hidden = !tieneAntes; });
          ahorro.forEach(function (a) { a.textContent = tieneAntes ? txtAhorro.replace('%', dinero(v.compare_at_price - v.price)) : ''; a.hidden = !tieneAntes; });
          botones.forEach(function (b) { b.disabled = !v.available; if (b.hasAttribute('data-mr-principal')) b.querySelector('span').textContent = v.available ? txtAgregar : txtAgotado; });
          if (v.featured_media) {
            var g = sec.querySelector('[data-mr-galeria]');
            if (g && g.__mrIr) g.__mrIr(v.featured_media.id);
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });

      box.querySelectorAll('[data-mr-cantidad]').forEach(function (c) {
        var inp = c.querySelector('input');
        c.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = parseInt(inp.value, 10) || 1;
            v = b.getAttribute('data-paso') === '-1' ? Math.max(1, v - 1) : v + 1;
            inp.value = v;
            sec.querySelectorAll('input[data-mr-cantidad-espejo]').forEach(function (e) { e.value = v; });
          });
        });
        inp.addEventListener('change', function () {
          sec.querySelectorAll('input[data-mr-cantidad-espejo]').forEach(function (e) { e.value = inp.value; });
        });
      });

      var barra = sec.querySelector('.mr-barra-movil');
      var ancla = box.querySelector('[data-mr-ancla]');
      if (barra && ancla && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { barra.classList.toggle('mr-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(ancla);
      }
    });
  }

  function initTodo() { initReveal(); initParallax(); initCifras(); initPasos(); initGaleria(); initCompra(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo); else initTodo();

  /* Editor de Shopify: re-inicializar al añadir/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initCifras(); initPasos(); initGaleria(); initCompra(); });
})();
